import { lazy, Suspense, type ComponentType, type ReactNode } from 'react'

/** Defer a legacy route wrapper while keeping its identity stable across navigation. */
export function lazyRouteLayout(
  load: () => Promise<{ default: ComponentType<{ children: ReactNode }> }>
) {
  const Layout = lazy(load)
  return function DeferredRouteLayout({ children }: { children: ReactNode }) {
    return (
      <Suspense fallback={null}>
        <Layout>{children}</Layout>
      </Suspense>
    )
  }
}
